import type { SVGProps } from "react";

export const LeafIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M17 8C8 8 5 14 5 19C5 20 6 21 7 21C12 21 18 18 18 9C18 8.45 17.55 8 17 8Z" />
    </svg>
  );
};
